<template>
  <!--语文作文题弹框 -->
  <el-dialog
    class="write-dialog dialog"
    width="550px"
    title="作文(语)"
    :visible="value"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('input', false)"
  >
    <el-form
      :model="formData"
      :rules="rulesFrom"
      label-width="100px"
      ref="formData"
      class="demo-Form"
    >
      <el-form-item label="大题题号：" prop="th">
        <el-select v-model="formData.th" placeholder="请选择" size="small">
          <el-option v-for="item in ths" :key="'th'+item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="limit-title" label="题目名称：" prop="name">
        <el-input
          class="topic_name"
          v-model="formData.name"
          type="text"
          placeholder="请输入内容"
          maxlength="27"
          show-word-limit
          size="small"
        ></el-input>
      </el-form-item>

      <el-form-item label="小题题号：" prop="start">
        <el-input-number v-model="formData.start" :controls="false" size="small" :min="1" :step="1" :step-strictly="true"></el-input-number>
      </el-form-item>

      <el-form-item :label="'字\xa0\xa0\xa0\xa0\xa0\xa0数：'" prop="wordNum">
        <el-input-number v-model="formData.wordNum" :controls="false" size="small" :min="1" :max="1500" :step="1" :step-strictly="true"></el-input-number>
      </el-form-item>

      <el-form-item :label="'分\xa0\xa0\xa0\xa0\xa0\xa0值：'" prop="totalScore" >
        <el-input-number
          v-model="formData.totalScore"
          :controls="false"
          size="small"
          :precision="2"
        ></el-input-number>
        <span>分</span>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { THS } from "../constant";
import { WriteModel } from "./Write.model";
import { mapState } from "vuex";
import { initTopicBoxMixins } from '@/mixins/initTopicBoxFormData.mixins';

export default {
  name: "Write",
  props: ["value", "type", "subject"],
  mixins: [initTopicBoxMixins],
  computed: {
    ...mapState("card", {
      ths: (state) => state.THS,
    }),
  },

  data() {
    var tihaoR = (rule, value, callback) => {
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else {
        callback();
      }
    };
    return {
      place: "&nbsp;",
      loading: true,
      formData: new WriteModel(),
      rulesFrom: {
        th: [{ required: true, message: "必填", trigger: "blur" }],
        name: [{ required: true, message: "必填", trigger: "blur" }],
        start: [
          { required: true, message: "必填", trigger: "blur" },
          { validator: tihaoR, trigger: "blur" },
        ],
        wordNum: [{ required: true, message: "必填", trigger: "blur" }],
        totalScore: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    dialogClose() {
      if (this.subject) {
        this.subject.oldSubject = this.subject && JSON.parse(JSON.stringify(this.subject))
      }
      this.$emit('input', false)
    },
    dialogSubmit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitDisabled = true;
      let timer = setTimeout(() => {
        this.submitDisabled = false;
        clearTimeout(timer);
      }, 500);
      this.$refs["formData"].validate((valid) => {
        if (!valid) return;
        this.formData = new WriteModel(this.formData);
        this.$emit("submit-write", this.formData);
        if (this.subject) {
          this.subject.oldSubject = this.subject && JSON.parse(JSON.stringify(this.subject))
        }
      });
    },
  },
  watch: {
    value: {
      //handler:'test',
      handler(val) {
        if (val) {
          if (this.subject) {
            this.subject.oldSubject = this.subject && JSON.parse(JSON.stringify(this.subject))
          }
          this.subject
            ? (this.formData = new WriteModel(this.subject.oldSubject))
            : (this.formData = new WriteModel(this.type));
            this.clearHistoryTopicFormData()
        }

      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
